module.exports = __webpack_public_path__ + "8f8c1df0b1e5cb0d6de5eab711debea6.pdf";